import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SearchResultComponent } from './search-result.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchComponent } from './search/search.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationsLoader } from 'src/app/service/translations-loader';
import { NgxPaginationModule } from 'ngx-pagination';
import { ResultListComponent } from './result-list/result-list.component';
import { AliasQuestionComponent } from './alias-question/alias-question.component';
import { DYNAMIC_COMPONENT } from 'src/app/shared/dynamic-component-loader/dynamic-component.manifest';
import { PanelsModule } from 'src/app/shared/components/panels/panels.module';

@NgModule({
  declarations: [SearchResultComponent, SearchComponent, ResultListComponent, AliasQuestionComponent],
  exports: [SearchResultComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgxPaginationModule,
    PanelsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateModule,
        deps: [HttpClient],
        useClass: TranslationsLoader
      },
    })
  ],
  providers: [
    {provide: DYNAMIC_COMPONENT, useValue: SearchResultComponent},
  ],
})
export class SearchResultModule { }
